import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { customName, getColorFromId,getColorFromEmail } from "../../helpers/commonHelpers";

const RemoveAttendeesModal = React.memo((props) => {
  const { attendee, meetingData } = props;
  const handleSubmit = () => {
    props.handleSubmit();
  };
  const isMeetingOrganiser =
    meetingData?.createdById?.toString() === attendee?._id?.toString()
      ? true
      : false;
  return (
    <>
      <Modal
        show={props.isModalOpen}
        onHide={(e) => props.setIsModalOpen(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Attendee</Modal.Title>
        </Modal.Header>
        <Modal.Body className="meetings-modal-attendees-list">
          <div className="attendees-popup">
            <div className="attendee-content">
              <div
                className="attendee1 attendee-list sl attendee-list-circle"
                style={{
                  // backgroundColor: attendee?.profilePicture
                  //   ? undefined
                  //   : getColorFromId(attendee?._id),


                    backgroundColor: attendee?.profilePicture ? undefined : attendee._id ?
                     getColorFromId(attendee._id) : getColorFromEmail(attendee.email),
                
                }}
                key={attendee?._id}
              >
                {attendee?.profilePicture ? (
                  <img
                    src={`${process.env.REACT_APP_API_URL}${attendee.profilePicture}`}
                    alt=""
                    className="attendee-list-circle-img"
                    style={{
                     
                    }}
                    onError={(e) => {
                      e.target.onerror = null;
                      e.target.style.display = "none";
                      e.target.parentElement.innerText = customName(
                        attendee.name
                      );
                    }}
                  />
                ) : attendee?.name ? (
                  customName(attendee.name)
                ) : null}
              </div>
              <div className="action-cmnt-text">
                <p className="detail-name word-break">{attendee.name}</p>
                <p className="name-undertext detail-date-time comment-text">
                  {attendee.email} {attendee.isEmployee ? "" : "(Guest)"}
                </p>
              </div>
            </div>
            {props.allowRemove && isMeetingOrganiser === false ? (
              <div className="action-cmnt-text">
                <p className="detail-name word-break"> {props.message}</p>
              </div>
            ) : null}
          </div>
        </Modal.Body>
        {props.allowRemove && isMeetingOrganiser === false ? (
          <Modal.Footer>
            <Button
              variant=""
              onClick={(e) => props.setIsModalOpen(false)}
              className="add-btn add-minutes Mom-btn btn equal-line-height-btn"
            >
              <p>No</p>
            </Button>
            <Button
              variant=""
              onClick={handleSubmit}
              className="create-meeting-button Mom-btn btn equal-line-height-btn"
            >
              <p>Yes</p>
            </Button>
          </Modal.Footer>
        ) : null}
      </Modal>
    </>
  );
});

export default RemoveAttendeesModal;
